const initLoopingImageWithTextSlider = () => {
  if (window.__imageWithTextLoopPatched) {
    return;
  }
  window.__imageWithTextLoopPatched = true;

  if (!customElements || typeof customElements.whenDefined !== "function") {
    return;
  }

  customElements.whenDefined("slider-engine").then(() => {
    const SliderEngine = customElements.get("slider-engine");
    if (!SliderEngine || SliderEngine.__imageWithTextLoopApplied) {
      return;
    }
    SliderEngine.__imageWithTextLoopApplied = true;

    const proto = SliderEngine.prototype;

    const jumpToIndex = function (index) {
      if (typeof this.disableTransition === "function") {
        this.disableTransition();
      }
      this.currentSlide = index;
      if (typeof this.slideVisible === "function") {
        this.slideVisible(false, true);
      }
      this.setAttribute?.("current-slide", this.currentSlide);
      this.setArrowOpacity?.();
      this.setActive?.();
      this.setAutoHeight?.();
      this.progressBarReset?.();
      if (typeof this.enableTransition === "function") {
        requestAnimationFrame(() => this.enableTransition());
      }
    };

    const setupCloneConfig = function (forceStart = false) {
      if (this.dataset.useClones !== "true") {
        return;
      }
      const realCount = Number(this.dataset.slideCount);
      if (!realCount) {
        return;
      }
      this.__loopCloneConfig = {
        firstRealIndex: 1,
        lastRealIndex: realCount,
        lastCloneIndex: realCount + 1,
      };
      if (forceStart) {
        requestAnimationFrame(() => jumpToIndex.call(this, 1));
      }
    };

    const scheduleWrap = function (targetIndex) {
      clearTimeout(this.__loopCloneTimer);
      const delay = Math.max(
        0,
        Math.round(this.animationDuration || 0)
      );
      this.__loopCloneTimer = setTimeout(() => {
        jumpToIndex.call(this, targetIndex);
        this.autoSlideInit?.();
      }, delay);
    };

    const handleCloneWrap = function () {
      if (this.dataset.useClones !== "true" || !this.__loopCloneConfig) {
        return;
      }
      const firstCloneIndex = 0;
      const { firstRealIndex, lastRealIndex, lastCloneIndex } =
        this.__loopCloneConfig;

      if (this.currentSlide === firstCloneIndex) {
        scheduleWrap.call(this, lastRealIndex);
      } else if (this.currentSlide === lastCloneIndex) {
        scheduleWrap.call(this, firstRealIndex);
      }
    };

    const originalInit = proto.init;
    proto.init = function (...args) {
      const result = originalInit
        ? originalInit.apply(this, args)
        : undefined;
      setupCloneConfig.call(this, true);
      return result;
    };

    const originalOnChange = proto.onChange;
    proto.onChange = function (...args) {
      const result = originalOnChange
        ? originalOnChange.apply(this, args)
        : undefined;
      handleCloneWrap.call(this);
      return result;
    };
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initLoopingImageWithTextSlider);
} else {
  initLoopingImageWithTextSlider();
}
